import script from "./SixthIhramPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SixthIhramPage.vue?vue&type=script&setup=true&lang=js"

import "./SixthIhramPage.vue?vue&type=style&index=0&id=764995fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764995fd"]])

export default __exports__